import { Badge, DotIcon, Row } from "@hightouch/htui";
import type { CardPill } from "src/pages/ad-studio/insights/performance/view/types";

type CardPillsProps = { pills: readonly CardPill[] };

export const CardPills = ({ pills }: CardPillsProps) => (
  <Row gap={1} flexWrap="wrap">
    {pills.map((pill) => (
      <OverlayPill
        key={pill.kind === "status" ? "status" : pill.text}
        pill={pill}
      />
    ))}
  </Row>
);

const OverlayPill = ({ pill }: { pill: CardPill }) => {
  switch (pill.kind) {
    case "status": {
      return (
        <Badge
          variant="dark"
          size="sm"
          svgIcon={DotIcon}
          iconColor={pill.live ? "green.400" : "orange.400"}
        >
          {pill.label}
        </Badge>
      );
    }
    case "text": {
      return (
        <Badge variant="dark" size="sm">
          {pill.text}
        </Badge>
      );
    }
    default: {
      return pill satisfies never;
    }
  }
};
